import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

function LandingPage() {
  return (
    <div>
      {/* Header */}
      <header className="header">
        <div className="header-container">
          <img src="/trial-atlas-logo-white.png" alt="Trial Atlas" className="landing-header-logo" />
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Find Your Perfect Clinical Trial in Minutes, Not Hours</h1>
          <p>AI-powered conversational search that understands your needs and gets you connected instantly</p>
          <Link to="/search" className="cta-button">Start Searching Now →</Link>
        </div>
      </section>

      {/* Why Trial Atlas */}
      <section className="why-section">
        <div className="container">
          <h2 className="section-title">Why Trial Atlas?</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">💬</div>
              <h3>Just Talk Naturally</h3>
              <p>No complex forms or medical jargon. Just tell us what you're looking for in plain English.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">⚡</div>
              <h3>Instant Contact Info</h3>
              <p>Get trial coordinator names, phone numbers, and emails in seconds - not buried in PDFs.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">🎯</div>
              <h3>Smart Matching</h3>
              <p>Only see trials relevant to your specific condition, location, and age - no irrelevant results.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">🔄</div>
              <h3>Always Current</h3>
              <p>Real-time data from ClinicalTrials.gov - updated daily by trial sponsors.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison */}
      <section className="comparison-section">
        <div className="container">
          <h2 className="section-title">Why Trial Atlas Beats Standard AI & Search Tools</h2>
          <div className="comparison-container">
            {/* Trial Atlas Card */}
            <div className="comparison-card trial-atlas">
              <div className="comparison-badge">✓ Trial Atlas</div>
              <h3>Trial Atlas</h3>
              
              <div className="comparison-item">
                <div className="comparison-icon check">✓</div>
                <div className="comparison-text">Conversational AI that understands natural language</div>
              </div>
              
              <div className="comparison-item">
                <div className="comparison-icon check">✓</div>
                <div className="comparison-text">Instant contact information for trial coordinators</div>
              </div>
              
              <div className="comparison-item">
                <div className="comparison-icon check">✓</div>
                <div className="comparison-text">Real-time data updated daily from ClinicalTrials.gov</div>
              </div>
              
              <div className="comparison-item">
                <div className="comparison-icon check">✓</div>
                <div className="comparison-text">Smart matching based on condition, location, and age</div>
              </div>
              
              <div className="comparison-item">
                <div className="comparison-icon check">✓</div>
                <div className="comparison-text">Live enrollment status showing actively recruiting trials</div>
              </div>
              
              <div className="comparison-item">
                <div className="comparison-icon check">✓</div>
                <div className="comparison-text">No complex forms - just natural conversation</div>
              </div>
            </div>

            {/* Standard Tools Card */}
            <div className="comparison-card others">
              <h3>Standard AI & Search Tools</h3>
              
              <div className="comparison-item">
                <div className="comparison-icon cross">✗</div>
                <div className="comparison-text">Outdated training data from months or years ago</div>
              </div>
              
              <div className="comparison-item">
                <div className="comparison-icon cross">✗</div>
                <div className="comparison-text">Cannot access real-time trial status or enrollment info</div>
              </div>
              
              <div className="comparison-item">
                <div className="comparison-icon cross">✗</div>
                <div className="comparison-text">May suggest trials that ended or closed years ago</div>
              </div>
              
              <div className="comparison-item">
                <div className="comparison-icon cross">✗</div>
                <div className="comparison-text">No way to get current contact information for coordinators</div>
              </div>
              
              <div className="comparison-item">
                <div className="comparison-icon cross">✗</div>
                <div className="comparison-text">Limited to training cutoff date - misses all new trials</div>
              </div>
              
              <div className="comparison-item">
                <div className="comparison-icon cross">✗</div>
                <div className="comparison-text">Complex forms on ClinicalTrials.gov or can't verify AI responses</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-section">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Tell Us What You Need</h3>
              <p>Just describe the condition, location, and patient age in your own words</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Get Smart Matches</h3>
              <p>Our AI finds the most relevant trials from 400,000+ options</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Connect Instantly</h3>
              <p>Get contact details and reach out to trial coordinators right away</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="final-cta">
        <div className="container">
          <h2>Ready to Find Your Trial?</h2>
          <p>Join thousands of patients finding hope through clinical research</p>
          <Link to="/search" className="cta-button">Start Your Search →</Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-disclaimer">
            <strong>Medical Disclaimer:</strong> Trial Atlas is for informational purposes only and does not provide medical advice. Always consult qualified healthcare professionals before making decisions about clinical trial participation or medical treatment.
          </div>
          <p style={{ marginTop: '10px', fontSize: '14px', opacity: 0.8 }}>Data powered by ClinicalTrials.gov API</p>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;